import { render, staticRenderFns } from "./accordian.vue?vue&type=template&id=9f04a448&scoped=true&"
import script from "./accordian.vue?vue&type=script&lang=js&"
export * from "./accordian.vue?vue&type=script&lang=js&"
import style0 from "./accordian.vue?vue&type=style&index=0&id=9f04a448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f04a448",
  null
  
)

export default component.exports